<script>
import {
  shippingMethodClickAndCollectEmits,
  shippingMethodClickAndCollectProps,
  useShippingMethodClickAndCollect
} from "./mixin";
import Button from "@/components/atoms/button";
import Card from "@/components/molecules/card";
import Titre from "@/components/atoms/titre";
import StickyFooter from "@/components/molecules/sticky-footer";
import Icon from "@/components/atoms/icon";
import Popin from "@/components/molecules/popin";

export default {
  name: "ShippingMethodClickCollectMobile",
  components: {
    Button,
    Card,
    Titre,
    StickyFooter,
    Icon,
    Popin
  },
  props: {
    ...shippingMethodClickAndCollectProps()
  },
  emits: [...shippingMethodClickAndCollectEmits()],
  setup(props, context) {
    const { timetable, msgNonRetrait, applyUpdateModeCommande } =
      useShippingMethodClickAndCollect(props, context);

    return {
      timetable,
      msgNonRetrait,
      applyUpdateModeCommande
    };
  }
};
</script>

<template>
  <div>
    <Card
      variant="grey-7"
      class="u-px-sm u-pt-sm u-pb-md"
    >
      <Titre
        tag="h2"
        size="sm"
        class="u-mr-lg u-mb-sm"
      >
        Votre point de retrait
      </Titre>
      <p class="u-font-15">
        <strong class="u-mr-xs">{{ service.description }}</strong>
      </p>
      <p class="u-font-15 u-mb-sm">
        {{ service.adresse }}
        <br>
        {{ service.details }}
      </p>
    </Card>

    <div class="u-my-lg u-px-sm">
      <div class="u-inline-flex">
        <Icon
          v-if="service.delai_securite === 2"
          name="chrono"
          class="u-mr-xs u-flex u-flex-self-start u-flex-shrink-none"
          size="lg"
          variant="primary"
        />
        <div>
          <p
            v-if="infosModeCommande"
            class="u-mb-xs"
          >
            Votre commande sera disponible {{ infosModeCommande.planning_mini_txt }}
          </p>
          <Button
            link
            @click="$refs.info.show()"
          >
            <p class="u-font-14">
              Voir les horaires Click & Collect
            </p>
          </Button>
        </div>
      </div>
      <p
        v-if="msgNonRetrait"
        class="u-mt-lg u-mb-lg u-text-xs u-color-grey-3 u-font-13 u-text-left"
      >
        {{ msgNonRetrait }}
      </p>
    </div>
    <StickyFooter class="u-text-center">
      <Button
        variant="secondary"
        radius="full"
        size="md"
        :disabled="!service"
        @click="applyUpdateModeCommande"
      >
        Je valide mon Click & Collect
      </Button>
    </StickyFooter>
    <Popin
      v-if="timetable.length > 0"
      ref="info"
      slide-up
      aria-label="Horaires Click & Collect"
    >
      <Titre
        tag="h2"
        size="sm"
        class="u-mb-md"
        variant="primary"
      >
        Horaires Click & Collect<br> {{ magasinName }}
      </Titre>
      <div
        v-for="(jour) in timetable"
        :key="jour.jour_numero"
        class="u-flex u-flex-justify-between u-flex-align-center u-mb-sm"
      >
        <div>{{ jour.jour }}</div>
        <template v-if="jour.dates.length>1">
          <div>
            <div>{{ jour.dates[0].from }} - {{ jour.dates[0].to }}</div>
            <div>{{ jour.dates[1].from }} - {{ jour.dates[1].to }}</div>
          </div>
        </template>
        <div v-else>
          {{ jour.dates[0].from }} - {{ jour.dates[0].to }}
        </div>
      </div>
    </Popin>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/schedule.scss";
</style>
